// extracted by mini-css-extract-plugin
module.exports = {"main":"Landingscreen_main__28CNF","router":"Landingscreen_router__3vlJ6"};